var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useState, useEffect } from '@max/max';
import './index.scss';
import { RequestType, useRequestList } from './hooks/useRequestList';
import { SHOW_TYPE } from './types/fe';
import { createFeSuperGroupGoodsList } from './utils/super-group-utils';
import { BID_MAP, BID_TYPE } from './common/lx';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { getUserInfo } from '@nibfe/mkt-user-api';
import { commonParams2RequestParams, API_PATH } from './utils/request';
import ListContainer from './components/list-container';
import SuperGroupGoodsItem from './components/super-group-goods-item';
import SuperGroupGoodsItemHorizontal from './components/super-group-goods-item-horizontal';
// 默认全国
export const DEFAULT_CITY_ID = 0;
const MyComponent = (componentConfig) => {
    var _a, _b;
    const ctx = useMonitorEngineContext();
    const { mainAreaBgColor, loadMoreTextColor, showType, loadMoreType } = componentConfig;
    const commonParams = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) !== null && _b !== void 0 ? _b : {};
    const [cityId, setCityId] = useState(DEFAULT_CITY_ID);
    const [isReceivedCityChange, setIsReceivedCityChange] = useState(false);
    const [userInfo, setUserInfo] = useState({
        userId: commonParams === null || commonParams === void 0 ? void 0 : commonParams.userId,
        token: commonParams === null || commonParams === void 0 ? void 0 : commonParams.token
    });
    // 飙升榜
    const { feListVo, requestList, listStatus, loadMoreStatus, isLastPage } = useRequestList(createFeSuperGroupGoodsList, componentConfig.pageSize, componentConfig);
    // 埋点上报
    function lxReport(bid, bidType, extraVal) {
        var _a, _b, _c, _d;
        try {
            const { hotelchannel } = (((_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) || {});
            const lxCommonParams = {
                hotel_channel: hotelchannel,
                city_id: cityId
            };
            const valLab = extraVal ? Object.assign(Object.assign({}, lxCommonParams), extraVal) : lxCommonParams;
            switch (bidType) {
                case BID_TYPE.MV:
                    (_b = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _b === void 0 ? void 0 : _b.mvReport(bid, {
                        valLab: Object.assign(Object.assign({}, valLab), { custom: valLab })
                    });
                    break;
                case BID_TYPE.MC:
                    (_c = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _c === void 0 ? void 0 : _c.mcReport(bid, {
                        valLab: Object.assign(Object.assign({}, valLab), { custom: valLab })
                    });
                    break;
                case BID_TYPE.MC_WITH_TAG:
                    (_d = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _d === void 0 ? void 0 : _d.mcReportWithTag(bid, {
                        valLab: Object.assign(Object.assign({}, valLab), { custom: valLab })
                    });
                    break;
            }
        }
        catch (error) {
            ctx._raptorReport.reportLog('上报埋点异常', error, {
                category: 'jsError',
                level: 'warn',
                tags: {
                    bid
                }
            });
        }
    }
    function loadRankListData(requestType) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseParams = commonParams2RequestParams(commonParams);
            const requestConfig = {
                path: API_PATH.STATIC_SUPPLY_DELIVERY,
                method: 'POST',
                // pageSize和PageNo，在hook里处理了，这里不需要传
                // @ts-ignore
                params: Object.assign(Object.assign({}, baseParams), { userId: userInfo.userId, token: userInfo.token, cityId, productGroupId: componentConfig.supplyId })
            };
            requestList({
                requestConfig
            }, requestType);
        });
    }
    useEffect(() => {
        var _a, _b;
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('cityChanged', (city) => {
            if (city === null || city === void 0 ? void 0 : city.value) {
                if (typeof city.value === 'string') {
                    setCityId(Number(city.value));
                }
                else {
                    setCityId(city.value);
                }
            }
            else {
                setCityId(DEFAULT_CITY_ID);
            }
            setIsReceivedCityChange(true);
        });
        if (!userInfo.userId || !userInfo.token) {
            if (typeof ((_b = ctx === null || ctx === void 0 ? void 0 : ctx._userAPI) === null || _b === void 0 ? void 0 : _b.forceLogin) === 'function') {
                ctx._userAPI.forceLogin().then(res => {
                    const { userId, token } = ctx._runtimeInfo.commonParams;
                    if (userId && token) {
                        setUserInfo({
                            userId,
                            token
                        });
                    }
                });
            }
            else {
                getUserInfo().then((res) => {
                    const { userId, token } = res;
                    if (userId && token) {
                        setUserInfo({
                            userId,
                            token
                        });
                    }
                });
            }
        }
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('cityChanged');
        };
    }, []);
    useEffect(() => {
        if (userInfo.userId && userInfo.token) {
            if (componentConfig.isRelatedCityFilter && !isReceivedCityChange) {
                return;
            }
            loadRankListData(RequestType.INIT);
        }
    }, [cityId, userInfo, isReceivedCityChange, componentConfig.isRelatedCityFilter]);
    return <ListContainer vo={{
            list: feListVo !== null && feListVo !== void 0 ? feListVo : []
        }} feConfig={componentConfig} onContainerShow={() => { }} onRetry={() => { }} ChildComponent={showType === SHOW_TYPE.VERTICAL_DOUBLE ? SuperGroupGoodsItem : SuperGroupGoodsItemHorizontal} onLoadMore={() => {
            loadRankListData(RequestType.LOAD_MORE);
        }} onCardShow={(vo, index) => {
            lxReport(BID_MAP.GOODS_ITEM_MV, BID_TYPE.MV, {
                index,
                spu_id: vo.id
            });
        }} onCardClick={(vo, index) => {
            lxReport(BID_MAP.GOODS_ITEM_MC, BID_TYPE.MC_WITH_TAG, {
                index,
                spu_id: vo.id
            });
        }} listStatus={listStatus} loadMoreStatus={loadMoreStatus} loadMoreType={loadMoreType} isLastPage={isLastPage} showType={showType} listContainerStyle={{
            backgroundColor: mainAreaBgColor,
            width: '750rpx'
        }} styleOptions={{
            loadMoreTextColor
        }}/>;
};
export default memo(MyComponent);
